export default __webpack_public_path__ + "static/media/prog.5757081a.svg";